<template>
  <div v-loading="loading" class="tyshxydmBody">
    <div class="_title">
      <p class="_title_info">查询公安信息</p>
    </div>
    <el-form
      label-position="right"
      class="_jbxxForm"
      label-width="200px"
    >
      <el-form-item label="公安账号：" prop="loginName">
        <el-input v-model="loginName" />
      </el-form-item>
      <div class="buttonList">
        <el-button @click="reset"> 重 置 </el-button>
        <el-button type="primary" @click="submit"> 确 认 </el-button>
      </div>
    </el-form>
    <el-descriptions v-if="localData" class="descriptions" title="查询结果" :column="1" :size="size" border>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-user" />
          账号
        </template>
        {{ localData.loginName }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-mobile-phone" />
          部门
        </template>
        {{ localData.deptName }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-office-building" />
          角色
        </template>
        {{ localData.roleLabel }}
      </el-descriptions-item>
    </el-descriptions>

  </div>
</template>

<script>
import { getUserBfxx } from '@/assets/js/system.js'
export default {
  name: 'Tyshxydm',
  data() {
    return {
      loading: false,
      loginName: '',
      localData: false
    }
  },
  methods: {
    reset() {
      this.loginName = ''
      this.localData = false
    },
    submit() {
      if (!this.loginName) {
        this.$message.warning('公安账号必填')
        return
      }
      this.loading = true
      this.localData = false
      getUserBfxx(this.loginName)
        .then((e) => {
          this.loading = false
          if (e.status === 200) {
            this.localData = e.data.data
          }
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang='less' scoped>
.tyshxydmBody {
  padding: 20px;
  background-color: white;
  margin: 10px;
  height: calc(100% - 20px);
  ._title {
    margin-top: 50px;
    width: 100%;
    ._title_info {
      text-align: center;
      font-size: 23px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #434343;
      line-height: 32px;
      height: 32px;
      font-family: Helvetica;
    }
  }
  ._jbxxForm {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 100px auto 0px auto;
    width: 50%;

    .el-form-item {
      margin-right: 0;
      width: 100%;
      /deep/.el-form-item__content {
        display: flex !important;
      }
    }
  }
  .buttonList {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 50px auto 0px auto;
    width: 50%;
  }
}
.descriptions {
    width: 70%;
    margin: 0 auto;;
}
</style>
